import { render, staticRenderFns } from "./sider-right.vue?vue&type=template&id=5976530e&scoped=true"
import script from "./sider-right.vue?vue&type=script&lang=js"
export * from "./sider-right.vue?vue&type=script&lang=js"
import style0 from "./sider-right.vue?vue&type=style&index=0&id=5976530e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5976530e",
  null
  
)

export default component.exports